import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const riego = createAsyncThunk(
    'riego/getRiego',
    async () => {
        try {
            const request = await axios.get("/api/sensor/getRiego")
            return request.data
        } catch (error) {
            throw error
        }
    }
)
